/* unplugin-vue-components disabled */import script from "./ComplaintsWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComplaintsWidget.vue?vue&type=script&setup=true&lang=ts"

import "./ComplaintsWidget.vue?vue&type=style&index=0&id=5415e9ba&lang=scss"

const __exports__ = script;

export default __exports__